import type { ChangeEvent, ReactNode } from 'react';

import './active-consent-payment-terms.scss';
import { AlertWarningIcon, Checkbox } from '@ctct/payflow-ui';

interface ActiveConsentPaymentTermsProps {
  children?: ReactNode;
  hasConsented: boolean;
  onChange: (hasConsented: boolean) => void;
  errorMessage?: null | string;
  id?: string;
  a11yTitle?: string;
}

export function ActiveConsentPaymentTerms({
  children,
  hasConsented,
  onChange,
  errorMessage,
  id,
  a11yTitle,
}: ActiveConsentPaymentTermsProps) {
  return (
    <div className="payflow-presentation payflow-active-consent-payment-terms">
      <div className="consent-terms-container">
        <Checkbox
          id={id}
          title={a11yTitle}
          checked={hasConsented}
          onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target!.checked)}
        />
        <div className="consent-terms-content">{children}</div>
      </div>
      {errorMessage && (
        <div className="error-message">
          <AlertWarningIcon /> <span>{errorMessage}</span>
        </div>
      )}
    </div>
  );
}
